<template>
    <div class="redate-wrap">
        <!--  重置有效期 -->
        <a-modal
            title='重置有效期'
            :visible="visibleRedate"
            :width="540"
            :confirmLoading="confirmLoading"
            :destroyOnClose="true"
            @cancel="closeModalRedate"
            @ok="handleCreateRedate"
            >
            <a-form :form="form">
                <div class="mb16">当前有效期为：{{ticketData.validStartTime}} ~ {{ticketData.validEndTime}}</div>
                <a-form-item label="用户缴费金额" :labelCol="{span: 6}" :wrapperCol="{span: 18}">
                    <a-input-number :precision="2" placeholder="请输入" style="width: 100%;" :min="0" v-decorator="['price',{rules:[{required: true, message: '请输入'}]}]" />
                </a-form-item>
                <a-form-item label="有效期重置为" :labelCol="{span: 6}" :wrapperCol="{span: 18}" :required="true">
                    <a-date-picker style="width: 164px" :disabled="true" :showToday="false" v-decorator="['afterValidStartTime', {initialValue: $moment(ticketData.validStartTime), rules:[{required: true, message: '请选择'}]}]"></a-date-picker>
                    <span class="redate-center">~</span>
                    <a-date-picker style="width: 165px" :showToday="false" :disabledDate="disabledDate" v-decorator="['afterValidEndTime', {initialValue: $moment(ticketData.validEndTime), rules:[{required: true, message: '请选择'}]}]" ></a-date-picker>
                </a-form-item>
                <remark :labelSpan="6" :wrapperSpan="18" operateCode="ValidityReset" />
                <shop :labelSpan="6" :wrapperSpan="18" :shops="ticketData.suitShopReserveStockConfigs"/>
            </a-form>
        </a-modal>
        <order-pay ref="orderPay" @payCallback="closeModalRedate" :isServeOrder="1"></order-pay>
    </div>
</template>

<script>
    import OrderPay from "@/components/modules/order/order-pay.component";
    import remark from '@/components/modules/platform/remark.component';
    import shop from '@/components/modules/platform/shop.component';
    /**
     * 日期重置组件
     * @prop {Object} ticketData 基础卡对象
     * @prop {Boolean} visibleRedate 控制退款弹窗是否显示
     *
     * @func closeModalRedate 通知父组件关闭退款弹窗
     *
     */
    export default {
        name: "member-order-redate",
        zh: "日期重置组件",
        components: {
            OrderPay,
            remark,
            shop,
        },
        data() {
            return {
                confirmLoading: false,
            };
        },
        props: {
            ticketData: {type: Object},
            visibleRedate: {type: Boolean},
        },
        methods: {
            disabledDate(current) {
                return current < this.$moment();
            },
            handleCreateRedate() {
                this.form.validateFields({force: true}, (errors, values) => {
                    if (!errors) {
                        const shopItem = JSON.parse(values.shop)
                        this.confirmLoading = true
                        this.$api.order.newValidityReset({
                            body: {
                                phone: this.ticketData.phone,
                                userTicketNo: this.ticketData.userTicketNo,
                                userId: this.ticketData.userId,
                                afterValidStartTime: values.afterValidStartTime.format('YYYY-MM-DD 00:00:00'),
                                afterValidEndTime: values.afterValidEndTime.format('YYYY-MM-DD 23:59:59'),
                                amount: values.price,
                                shopId: shopItem.id,
                                shopName: shopItem.name,
                                remark: values.remark,
                                remarkCategoryCode: values.remarkCategoryCode,
                                remarkCategoryName: values.remarkCategoryName,
                            }
                        }).then(res => {
                            this.confirmLoading = false
                            this.$refs.orderPay.orderId = res || '';
                            this.$refs.orderPay.userId =  this.ticketData.userId;
                        }).catch(err => {
                            this.confirmLoading = false;
                        });
                    }
                });
            },
            closeModalRedate() {
                setTimeout(() => {
                    this.form.resetFields();
                    this.$emit('changeVisibleRedate', false);
                },300);

            },
        },
        beforeCreate() {
            this.form = this.$form.createForm(this)
        },
        created() {},
        updated() {},
        mounted() {},
        computed: {},
        watch: {
            'ticketData'(val) {
                this.ticketData = val
            }
        }
    };
</script>

<style lang="scss">
.redate {
    &-center {
        padding: 0 10px;
        color: #AAA;
    }
}
</style>
